/**
 * @generated SignedSource<<943191deb05ffa864a97756ed8ff9a99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IndustriesList_Query$variables = Record<PropertyKey, never>;
export type IndustriesList_Query$data = {
  readonly industries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type IndustriesList_Query = {
  response: IndustriesList_Query$data;
  variables: IndustriesList_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 20
      }
    ],
    "concreteType": "IndustryConnection",
    "kind": "LinkedField",
    "name": "industries",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IndustryEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Industry",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "industries(first:20)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IndustriesList_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IndustriesList_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3920c5c33c1dca9061b5ac0e919c27e0",
    "id": null,
    "metadata": {},
    "name": "IndustriesList_Query",
    "operationKind": "query",
    "text": "query IndustriesList_Query {\n  industries(first: 20) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6812caaf17d4fbdddcc656304eb87704";

export default node;
